import React, { useState } from 'react';

function Accounting() {
  const [regime, setRegime] = useState('УСН');
  const [income, setIncome] = useState('');
  const [expense, setExpense] = useState('');
  const [result, setResult] = useState(null);

  // Конфигурация для каждого налогового режима
  const regimes = {
    'УСН': {
      rates: '6% (доходы) или 15% (доходы−расходы)',
      calendar: [
        { date: '28 апреля', event: 'Аванс по УСН за 1 квартал', type: 'tax', day: 28, month: 4 },
        { date: '28 июля', event: 'Аванс по УСН за 2 квартал', type: 'tax', day: 28, month: 7 },
        { date: '28 октября', event: 'Аванс по УСН за 3 квартал', type: 'tax', day: 28, month: 10 },
        { date: '31 марта', event: 'Декларация по УСН за год', type: 'declaration', day: 31, month: 3 },
      ],
      benefits: [
        'Льгота для IT-компаний: ставка 5% вместо 6%',
        'Уменьшение налога на страховые взносы (до 50%)',
      ],
    },
    'ОСНО': {
      rates: 'Налог на прибыль 25%, НДС 22%',
      calendar: [
        { date: '20 числа ежемесячно', event: 'НДС за предыдущий месяц', type: 'tax', day: 20, month: 1 },
        { date: '28 числа ежемесячно', event: 'Аванс по налогу на прибыль', type: 'tax', day: 28, month: 1 },
        { date: '28 марта', event: 'Декларация по налогу на прибыль за год', type: 'declaration', day: 28, month: 3 },
      ],
      benefits: [
        'Возмещение НДС при экспорте',
        'Амортизация основных средств',
      ],
    },
    'ПСН': {
      rates: 'Фиксированная стоимость патента (зависит от региона)',
      calendar: [
        { date: 'При оформлении', event: 'Оплата патента (срок зависит от периода)', type: 'tax', day: 1, month: 1 },
      ],
      benefits: [
        'Нет отчётности — патент освобождает от декларации',
        'Фиксированная стоимость — не зависит от дохода',
      ],
    },
  };

  const currentRegime = regimes[regime] || regimes['УСН'];

  const getDaysUntil = (day, month) => {
    const now = new Date();
    const year = now.getFullYear();
    const target = new Date(year, month - 1, day);
    if (target < now) target.setFullYear(year + 1);
    const diff = Math.ceil((target - now) / (1000 * 60 * 60 * 24));
    return diff;
  };

  const getReminderText = (item) => {
    const days = getDaysUntil(item.day, item.month);
    if (days === 0) return { text: 'Сегодня!', color: '#EF4444' };
    if (days === 1) return { text: 'Завтра!', color: '#EF4444' };
    if (days <= 5) return { text: `До платежа ${days} дн.`, color: '#F59E0B' };
    if (days <= 14) return { text: `До платежа ${days} дн.`, color: '#10B981' };
    return { text: `Через ${days} дн.`, color: '#94A3B8' };
  };

  const calculateTax = () => {
    const inc = parseFloat(income) || 0;
    const exp = parseFloat(expense) || 0;

    let tax = 0;
    let details = '';

    if (regime === 'УСН') {
      const tax6 = inc * 0.06;
      const profit = inc - exp;
      const tax15 = profit > 0 ? profit * 0.15 : 0;
      tax = Math.min(tax6, tax15);
      details = `УСН 6%: ${tax6.toLocaleString()} ₽ | УСН 15% (доходы−расходы): ${tax15.toLocaleString()} ₽\nВыбран минимальный налог: ${tax.toLocaleString()} ₽`;
    } else if (regime === 'ОСНО') {
      const profit = inc - exp;
      const profitTax = profit > 0 ? profit * 0.25 : 0;
      const vat = inc * 0.22;
      tax = profitTax + vat;
      details = `Налог на прибыль 25%: ${profitTax.toLocaleString()} ₽\nНДС 22%: ${vat.toLocaleString()} ₽\nИтого: ${tax.toLocaleString()} ₽`;
    } else if (regime === 'ПСН') {
      tax = 30000;
      details = `Патент (фиксированный): 30 000 ₽ в год\nСумма не зависит от дохода`;
    }

    setResult({ tax, details, income: inc, expense: exp });
  };

  const generateDeclaration = () => {
    if (!result) return;
    const today = new Date().toLocaleDateString('ru-RU');
    const decl = `НАЛОГОВАЯ ДЕКЛАРАЦИЯ ПО ${regime}
Дата формирования: ${today}
Налогоплательщик: ИП Иванов И.И.

Доходы за период: ${result.income.toLocaleString()} ₽
Расходы за период: ${result.expense.toLocaleString()} ₽
Налог к уплате: ${result.tax.toLocaleString()} ₽

Расчёт:
${result.details}

Подпись налогоплательщика: _______________
Дата: ${today}
`;
    alert(decl);
  };

  return (
    <div>
      <h2>📊 Налоговый калькулятор и декларация</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 20 }}>
        Выберите налоговый режим — система автоматически подстроит календарь, ставки и льготы
      </p>

      {/* Календарь платежей */}
      <div style={{ marginBottom: 24, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #334155' }}>
        <h3 style={{ marginBottom: 12 }}>📅 Календарь налоговых платежей ({regime})</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }}>
          {currentRegime.calendar.map((item, i) => {
            const reminder = getReminderText(item);
            return (
              <div key={i} style={{ padding: 12, background: '#0F172A', borderRadius: 8, border: '1px solid #334155' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: item.type === 'tax' ? '#F59E0B' : '#6366F1' }}>
                    {item.date}
                  </div>
                  <span style={{ fontSize: 12, fontWeight: 600, color: reminder.color }}>
                    {reminder.text}
                  </span>
                </div>
                <div style={{ fontSize: 13, color: '#94A3B8' }}>{item.event}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Льготы */}
      <div style={{ marginBottom: 24, padding: 16, background: 'rgba(16,185,129,0.1)', borderRadius: 12, border: '1px solid rgba(16,185,129,0.3)' }}>
        <h3 style={{ marginBottom: 8, color: '#10B981' }}>💡 Льготы для режима {regime}</h3>
        <ul style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20 }}>
          {currentRegime.benefits.map((b, i) => (
            <li key={i} style={{ marginBottom: 4 }}>{b}</li>
          ))}
        </ul>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 400, marginBottom: 20 }}>
        <label style={{ color: '#94A3B8', fontSize: 13 }}>Налоговый режим</label>
        <select value={regime} onChange={e => { setRegime(e.target.value); setResult(null); }} style={inputStyle}>
          <option>УСН</option>
          <option>ОСНО</option>
          <option>ПСН</option>
        </select>

        <div style={{ padding: 10, background: '#0F172A', borderRadius: 8, border: '1px solid #334155', fontSize: 13, color: '#94A3B8' }}>
          <strong>Ставки:</strong> {currentRegime.rates}
        </div>

        {regime !== 'ПСН' && (
          <>
            <label style={{ color: '#94A3B8', fontSize: 13 }}>Доходы (₽)</label>
            <input value={income} onChange={e => setIncome(e.target.value)} placeholder="Например: 5000000" style={inputStyle} />

            <label style={{ color: '#94A3B8', fontSize: 13 }}>Расходы (₽)</label>
            <input value={expense} onChange={e => setExpense(e.target.value)} placeholder="Например: 2000000" style={inputStyle} />
          </>
        )}

        <button onClick={calculateTax} style={{ padding: 12, background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, marginTop: 8 }}>
          Рассчитать налог
        </button>
      </div>

      {result && (
        <div style={{ padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #334155', marginBottom: 16 }}>
          <h3 style={{ marginBottom: 10, color: '#10B981' }}>Налог к уплате: {result.tax.toLocaleString()} ₽</h3>
          <pre style={{ color: '#94A3B8', fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
            {result.details}
          </pre>
          <button onClick={generateDeclaration} style={{ padding: '10px 20px', background: '#10B981', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, marginTop: 12 }}>
            📄 Сформировать декларацию
          </button>
        </div>
      )}

      <div style={{ padding: 14, background: '#1E293B', borderRadius: 8, border: '1px solid #334155' }}>
        <h4 style={{ marginBottom: 6 }}>Информация о налоговых режимах (2026)</h4>
        <ul style={{ color: '#94A3B8', fontSize: 13, paddingLeft: 20 }}>
          <li>УСН: 6% (доходы) или 15% (доходы−расходы). Порог — 20 млн ₽ для освобождения от НДС.</li>
          <li>ОСНО: налог на прибыль 25%, НДС 22%.</li>
          <li>ПСН: фиксированная стоимость патента (зависит от региона и вида деятельности).</li>
        </ul>
      </div>
    </div>
  );
}

const inputStyle = { padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC', fontSize: 14 };

export default Accounting;